import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PatientsService } from '../../core/services/patients.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'bemum-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: false,
})
export class RegisterComponent implements OnInit {
  public form!: UntypedFormGroup;
  public emailExist = false;

  constructor(
    private fb: UntypedFormBuilder,
    private readonly patientService: PatientsService,
    private readonly notificationService: NzNotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const franceorLuxembourgorBelgiumPhonePattern = new RegExp(
      /^((?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$|((\+|00\s?)352)?\s?6[269]1(\s?\d{3}){2}$)|(((\+|00)32[ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})$/,
    );

    this.form = this.fb.group({
      firstname: [null, [Validators.required]],
      lastname: [null, [Validators.required]],
      email: [
        null,
        [
          (control: UntypedFormControl) => {
            if (!control.value || !control.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
              return { required: true };
            }
            return {};
          },
        ],
        [
          (control: UntypedFormControl) => {
            return control.value
              ? this.patientService.checkEmail(control.value).pipe(
                  map(() => null),
                  catchError(() => of({ emailExist: true })),
                )
              : of(null);
          },
        ],
      ],

      phoneNumber: [null, [Validators.required, Validators.pattern(franceorLuxembourgorBelgiumPhonePattern)]],
      password: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            /(((?=.*\W+)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*\W+)(?=.*[a-z]))|((?=.*\d)(?=.*\W+)(?=.*[A-Z]))).*$/,
          ),
          this.passwordValidators,
        ],
      ],
      checkPassword: [null, [Validators.required, this.passwordMatchValidator]],
      agreestoTerms: true,
    });
  }

  passwordValidators = (control: UntypedFormControl): { [s: string]: boolean } => {
    if (this.form && control) {
      if (!control.value) {
        return { required: true };
      } else if (
        !control.value.match(
          /(((?=.*\W+)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*\W+)(?=.*[a-z]))|((?=.*\d)(?=.*\W+)(?=.*[A-Z]))).*$/,
        )
      ) {
        return { pattern: true, error: true };
      }
      return {};
    }
  };

  passwordMatchValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    if (this.form && control) {
      if (!control.value) {
        return { required: true };
      } else if (
        !control.value.match(
          /(((?=.*\W+)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*\W+)(?=.*[a-z]))|((?=.*\d)(?=.*\W+)(?=.*[A-Z]))).*$/,
        )
      ) {
        return { pattern: true, error: true };
      } else if (control.value !== this.form.controls.password.value) {
        return { confirm: true, error: true };
      }
      return {};
    }
  };

  submitForm() {
    if (this.form.valid) {
      const credentials = this.form.value;
      this.patientService.createPatient(credentials).subscribe({
        next: () => {
          this.notificationService.success(
            'Inscription terminée',
            "Votre inscription a bien été prise en compte et vous pouvez désormais vous connecter à l'application BeMum",
          );
          this.router.navigateByUrl('/');
        },
        error: () => {
          this.notificationService.error(
            'Une erreur est survenue',
            "L'opération a échoué, veuillez réessayer ultérieurement",
          );
        },
      });
    }
  }
}
